// extracted by mini-css-extract-plugin
module.exports = {"loader":"vb","smallLoader":"wb","loading-keyframes":"xb","pageLoader":"yb","centered":"zb","whitespacePlaceholder":"Ab","buttonSpinner":"Bb","fade-in":"Cb","rotate":"Db"};